import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';
import { Box } from '@mui/material';

export const StyledLightningLinkSaleBadge = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);

  img {
    width: 100%;
    height: 100%;
    max-height: 24px;
    max-width: 80px;
    object-fit: cover;
  }

  .number {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: none;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
` as any;
